import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'api/axiosInstance';
import endpoints from 'api/endpoints';
import AppoinmentTest from './AppoinmentTest';

// Hosts that should NOT trigger custom-domain resolution —
// they have their own routes (landing page, admin dashboard, etc.)
const MAIN_HOSTS = new Set([
  'zoidesq.com',
  'www.zoidesq.com',
  'appointments.zoiteckh.com',
  'localhost',
  '127.0.0.1',
]);

/**
 * Root-path component that inspects the current hostname.
 *
 * - If host is in MAIN_HOSTS → fall through to the normal landing page.
 * - Otherwise → look up the host via /api/core/domain-lookup/.
 *   If a company is found, render AppoinmentTest with the resolved slug
 *   (URL stays bare, no redirect). If not found, fall through to landing.
 */
export default function CustomDomainRoute({ fallback }) {
  const [state, setState] = useState({ loading: true, slug: null });

  useEffect(() => {
    const host = window.location.hostname;
    if (MAIN_HOSTS.has(host)) {
      setState({ loading: false, slug: null });
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const resp = await axios.get(endpoints.domainLookup(host));
        if (cancelled) return;
        setState({ loading: false, slug: resp.data?.found ? resp.data.slug : null });
      } catch {
        if (!cancelled) setState({ loading: false, slug: null });
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (state.loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', color: '#94A3B8', fontSize: '0.9rem' }}>
        Loading…
      </div>
    );
  }

  if (state.slug) {
    // Render the tenant's booking page at root — no URL change
    return <AppoinmentTest slugOverride={state.slug} />;
  }

  // Not a custom domain → use the fallback (landing page)
  return fallback;
}
